import { render, staticRenderFns } from "./precision-task.vue?vue&type=template&id=a6279dde&scoped=true"
import script from "./precision-task.vue?vue&type=script&lang=js"
export * from "./precision-task.vue?vue&type=script&lang=js"
import style0 from "./precision-task.vue?vue&type=style&index=0&id=a6279dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6279dde",
  null
  
)

export default component.exports